import {
	STEP_PARAPHEUR,
	STEP_TELETRANSMISSION,
	STEP_UTILISATEUR,
} from '../constants/utilisateurStep';

// Retourne l'index de l'étape à afficher selon les cases cochées et le type d'étape demandé
export default function getCurrentStepIndex({
	isSignataireParapheur,
	isAgentTeletransmetteur,
	stepType,
}: {
	isSignataireParapheur: boolean;
	isAgentTeletransmetteur: boolean;
	stepType: number;
}): number {
	// Toujours 0 pour l'étape utilisateur
	if (stepType === STEP_UTILISATEUR) return 0;
	// Si parapheur est coché, il est en 2e position (index 1)
	if (stepType === STEP_PARAPHEUR) {
		if (isSignataireParapheur) return 1;
		return -1; // n'existe pas
	}
	// Si télétransmetteur est coché, il est en 2e ou 3e position
	if (stepType === STEP_TELETRANSMISSION && isAgentTeletransmetteur) {
		if (isSignataireParapheur) return 2;
		if (!isSignataireParapheur) return 1;
		return -1; // n'existe pas
	}
	return -1;
}
